class AccordionNav {
    constructor($target) {
        $target = $target instanceof jQuery ? $target : $($target);

        // Track the parents of each sub nav
        let subNavParents = [];

        $target.find('li').each(function () {
            let $el = $(this);
            if ($el.find('ul').length) {
                // Indicate that this item has a sub nav
                this.className += ' has-sub-nav';

                // Add the open/close indicator
                $('<button class="indicator" data-toggle-subnav><span class="sr-only">Toggle subnav</span></button>')
                    .insertBefore($el.find('> ul'));

                subNavParents.push(this);
            }
        });

        $target.find('ul ul').addClass('sub-menu');

        let $subNavParents = $(subNavParents);

        this.registerEvents($target, $subNavParents);

    }

    registerEvents($target, $subNavParents) {

        // --- Register events for the nav  --- //
        // $target.on('nav:open', function () {
        //   $target.addClass('open').removeClass('close');
        //
        //   $target.find('.current').each(function () {
        //     $(this).parents('.has-sub-nav').trigger('subnav:open');
        //   });
        //
        //   $target.trigger('nav:opened');
        // }).on('nav:close', function () {
        //   $target.removeClass('open').addClass('close');
        //
        //   $target.trigger('nav:closed');
        // }).on('nav:toggle', function () {
        //   if ($target.hasClass('open')) {
        //     $target.triggerHandler('nav:close');
        //   } else {
        //     $target.triggerHandler('nav:open');
        //   }
        // });

        // --- Register events for the sub navs activator  --- //
        $target.find('[data-toggle-subnav]')
            .on('touchstart', function (event) {
                // Speed boost for mobile, skips 300ms delay
                event.preventDefault();
                $(this).trigger('click');
            }).on('click', function (event) {
            event.stopPropagation();

            let $parent = $(this).parents('.has-sub-nav').first();

            if ($parent.hasClass('open')) {
                $parent.triggerHandler('subnav:close');
            } else {
                $parent.triggerHandler('subnav:open');
            }
        });

        // --- Register events for the sub nav parents --- //
        $subNavParents.on('subnav:open', function () {
            let $nav = $(this);
            let $sub = $nav.find('.sub-menu').first();

            $sub.hide().removeClass('shut');

            $nav.addClass('open').removeClass('shut');

            $sub.slideDown(300, function () {
                $sub.addClass('open');
                $nav.triggerHandler('subnav:opened');
            });
        }).on('subnav:close', function () {
            let $nav = $(this);
            let $sub = $nav.find('.sub-menu').first();

            $nav.addClass('closing');

            $sub.slideUp(300, function () {
                $nav.addClass('shut').removeClass('open closing');
                $sub.addClass('shut').removeClass('open');
                $nav.triggerHandler('subnav:closed');
            });

            $nav.on('subnav:closed', function () {
                // Close all sub navs
                $nav.find('.has-sub-nav').triggerHandler('subnav:close');
            });
        });
    }
}

export default AccordionNav;
